module.exports = __webpack_public_path__ + "img/one_1.5b46559e.png";